import React,{ useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
  
    const navItems = [
      { name: "Inicio", path: "/" },
      { name: "Servicios", path: "/servicios" },
      { name: "Sobre Nosotros", path: "/sobre-nosotros" },
      { name: "Contacto", path: "/contacto" },
    ];
    return (
        <nav className="fixed w-full bg-white/80 backdrop-blur-md z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img
                  src="/lovable-uploads/a9798cf3-7218-47dd-992b-0613b6324f88.png"
                  alt="Aulanovus Logo"
                  className="h-8 w-auto"
                />
              </Link>
            </div>
  
            {/* Desktop menu */}
            <div className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`font-inter text-sm font-medium transition-colors hover:text-aulanovus-blue
                    ${
                      location.pathname === item.path
                        ? "text-aulanovus-blue"
                        : "text-gray-600"
                    }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
  
            {/* Mobile menu button */}
            <div className="flex items-center md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-gray-600 hover:text-aulanovus-blue focus:outline-none"
              >
                {isOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
  
        {/* Mobile menu */}
        {isOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-3 py-2 rounded-md font-medium ${
                    location.pathname === item.path
                      ? "text-aulanovus-blue bg-blue-50"
                      : "text-gray-600 hover:text-aulanovus-blue hover:bg-gray-50"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    );
};

export default Navbar;